import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKeypointDelete = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.74268 12C2.74268 13.2426 3.74268 14.2426 5.74268 16.2426L7.75739 18.2574C9.75739 20.2574 10.7574 21.2574 12 21.2574C13.2427 21.2574 14.2427 20.2574 16.2427 18.2574L18.2574 16.2426C20.2574 14.2426 21.2574 13.2426 21.2574 12C21.2574 10.7574 20.2574 9.75736 18.2574 7.75736L16.2427 5.74265C14.2427 3.74265 13.2427 2.74265 12 2.74265C10.7574 2.74265 9.75739 3.74265 7.75739 5.74265L5.74268 7.75736C3.74268 9.75736 2.74268 10.7574 2.74268 12ZM8 11C7.44771 11 7 11.4477 7 12C7 12.5523 7.44771 13 8 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H8Z",
		fill: "#DD0000"
	})
});
const ForwardRef = forwardRef(SvgKeypointDelete);
export { ForwardRef as ReactComponent };
